import { createFileRoute } from "@tanstack/react-router";
import BrandCityPage from "@/pages/BrandCityPage";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/vehicles/$brand/$city/")({
  head: ({ params }) => routeHead("/vehicles/$brand/$city/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <BrandCityPage />
  );
}
